import { apiClient } from "./api-client";
import { toArray } from "./api-utils";
import type { TriyoTask, TriyoTaskList } from "@/types/models";

export const TasksApi = {
  /**
   * Active tasks only, unpaged — the legacy add-in endpoint. Kept for callers
   * that just need the user's live work.
   */
  getUserTasks: async (): Promise<TriyoTask[]> => {
    const res = await apiClient.get<unknown>("/tasks/GetUserTaskListForAddin");
    return toArray<TriyoTask>(res.data, "Tasks", "tasks");
  },

  /**
   * One page of the user's tasks across every category, plus the server's own
   * totals per category. Paging is applied server-side via Skip/Take, and the
   * counts always describe the WHOLE task set rather than the returned page.
   */
  getUserTaskPage: async (page: number, pageSize: number): Promise<TriyoTaskList> => {
    const res = await apiClient.get<TriyoTaskList>("/Tasks/GetUserTasksForWeb", {
      params: { page, pageSize },
    });
    const data = res.data;
    if (!data || typeof data !== "object") return { Tasks: [] };
    return { ...data, Tasks: toArray<TriyoTask>(data, "Tasks", "tasks") };
  },
};
